import { useEffect, useRef } from "react";
import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from "web-vitals";

import { useHitParams } from "./logActions";
import { sendYMEvent } from "./metrika";

type HitParams = ReturnType<typeof useHitParams>;

const sendToYandexMetrika = (metric: Metric, hitParams: HitParams): void => {
  const { connection: { effectiveType } = {}, deviceMemory } =
    navigator as Navigator & {
      connection?: { effectiveType?: string };
      deviceMemory?: number;
    };
  const { id, name, delta, value, navigationType } = metric;

  sendYMEvent(name, "web-vitals", hitParams, {
    id,
    delta,
    value,
    deviceMemory,
    effectiveType,
    navigationType,
  });
};

const reportWebVitals = (hitParamsRef: { current: HitParams }): void => {
  onCLS((data) => sendToYandexMetrika(data, hitParamsRef.current));
  onLCP((data) => sendToYandexMetrika(data, hitParamsRef.current));
  onINP((data) => sendToYandexMetrika(data, hitParamsRef.current));
  onFCP((data) => sendToYandexMetrika(data, hitParamsRef.current));
  onTTFB((data) => sendToYandexMetrika(data, hitParamsRef.current));
};

export const useReportWebVitals = () => {
  const hitParams = useHitParams();
  const hitParamsRef = useRef(hitParams);

  useEffect(() => {
    hitParamsRef.current = hitParams;
  }, [hitParams]);

  useEffect(() => {
    reportWebVitals(hitParamsRef);
  }, []);
};
